import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subscription, takeUntil } from 'rxjs';
import { PlantList } from 'src/app/Modules/idms/components/plant-manager/models/plant-manager.model';
import { PlantmanagerService } from 'src/app/Modules/idms/components/plant-manager/services/plantmanager.service';
import { CalculationType } from 'src/app/Modules/informate/enums/calculation-type.enum';
import { TighteningMethod } from 'src/app/Modules/informate/enums/tightening-method.enum';
import {
    ClampInputData,
    ControlData,
    DiagramDataModel,
    DiagramInfo,
    DimensionOverridesInput,
    EngineeredJointInputData,
    ProcessInfoData,
    ProcessInfoModel,
    StdInputData,
    TighteningData,
} from 'src/app/Modules/informate/models';
import { CalculationResult, ToolOutput } from 'src/app/Modules/informate/models/calculationModels';
import { InputGroup } from 'src/app/Modules/informate/models/calculationModels/input-group';
import { IceapiService, IdmApiService, UserUtilityService } from 'src/app/services';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { DataService } from 'src/app/services/data.service';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { ToolSelectionComponent } from '../tool-selection/tool-selection.component';
import { PipeSpecificationCodes } from 'src/app/Modules/settings/models/idms/pipe-specification.model';
import { JointCalcService, PipeSpecpayload } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';

@Component({
    selector: 'app-joint-calculation-model',
    templateUrl: './joint-calculation-model.component.html',
    styleUrls: ['./joint-calculation-model.component.scss'],
    standalone: false,
})
export class JointCalculationModelComponent implements OnInit {
    @Input() calculationType: CalculationType;
    @Input() cssClass;
    @Input() i: boolean;

    @Output() CalculationResultString = new EventEmitter<any>();
    @ViewChild('beginbtn', { static: false }) beginbtn: ElementRef;
    public CalculationType = CalculationType;
    taggedItem: PlantList;
    calculationResult?: CalculationResult;
    stdFlangeInput: InputGroup;
    customFlangeInput: InputGroup;
    toolsData: ToolOutput[];
    processInfoInput: ProcessInfoModel;
    diagramInfo: DiagramDataModel;
    outputTabIndex = 0;
    selectedTool: ToolOutput;
    isInitialFormLoad: boolean = true;
    isInputValid: boolean = false;
    isTighteningInputValid: boolean = false;
    isStdInputValid: boolean = false;
    isProcessInfoInputValid: boolean = false;

    tooltip_position = 'above';
    tighteningform = false;
    stdInputform = false;
    processform = false;
    toolsform = false;
    showpaneltoggle = false;
    editpanel_1 = false;
    editpanel_2 = false;
    editpanel_3 = false;
    editpanel_4 = false;
    hideAdvanceOptionTab: boolean = true;
    isRedirect: string = 'false';
    processInfoForm: UntypedFormGroup;
    standardInputForm: UntypedFormGroup;
    tighteningProcedureForm: UntypedFormGroup;
    toolsFormGroup: UntypedFormGroup;
    LoadCalculationSubscription: Subscription;
    isOverriddenFlange: boolean;
    IsCalculationOutPutTabSelected: boolean = false;
    TypeDisabled: boolean = true;
    //For Custom Flange
    isOverrideFlangeValid: boolean = false;
    isOverrideFlangeFacingValid: boolean = false;
    isOverrideGasketValid: boolean = false;
    customInputForm: UntypedFormGroup;
    //End

    //For Clamp
    clampInputFormGroup: UntypedFormGroup;
    clampInput: InputGroup;
    //End
    //For Engineered Joint
    engJointInput: InputGroup;
    engineerJointInputFormGroup: UntypedFormGroup;
    isEngJointInputValid: boolean = false;
    enggJointform = false;
    customForm = false;
    isCustomInputValid: boolean = false;
    PageMethod: string = '';
    pipeCodes: PipeSpecificationCodes[] = [];
    pipeSpec: any;
    showComponents = true;
    constructor(
        private ngbActiveModal: NgbActiveModal,
        private ngxUiLoaderService: NgxUiLoaderService,
        private globalEmittersService: GlobalEmittersService,
        private iceapi: IceapiService,
        private user_utility: UserUtilityService,
        private customToastService: CustomToastService,
        private dataSvc: DataService,
        private PlantmanagerService: PlantmanagerService,
        private modelService: NgbModal,
        private cd: ChangeDetectorRef,
        private idmapiService: IdmApiService,
        private jointCalcService: JointCalcService
    ) {}

    //End
    ngOnInit(): void {
        this.getpipeSpec();
        if (this.calculationResult?.input?.calculationType == this.calculationType) {
            this.ngxUiLoaderService.start();
            if (this.calculationType == CalculationType.StandardFlange) {
                this.dataSvc.calculationData = this.calculationResult;
                this.stdFlangeInput = this.calculationResult.input;
                this.toolsData = this.calculationResult.output?.tools;
                this.stdInputform = true;
                this.processform = true;
            } else if (this.calculationType == CalculationType.CustomFlange) {
                this.dataSvc.calculationData = this.calculationResult;
                this.customFlangeInput = this.calculationResult.input;
                this.toolsData = this.calculationResult.output?.tools;
                this.customForm = true;
                this.isTighteningInputValid = true;
                this.isCustomInputValid = true;
                this.isProcessInfoInputValid = true;
                this.isOverrideFlangeFacingValid = true;
                this.isOverrideFlangeValid = true;
                this.isOverrideGasketValid = true;
                this.processform = true;
                this.isInputValid = true;
            } else if (this.calculationType == CalculationType.Clamp) {
                this.ngxUiLoaderService.start();
                this.dataSvc.calculationData = this.calculationResult;
                this.clampInput = this.calculationResult.input;
                this.toolsData = this.calculationResult.output?.tools;
                this.isInitialFormLoad = false;
                this.editpanel_1 = true;
                this.editpanel_2 = true;
                this.editpanel_4 = true;
                this.tighteningform = true;
                this.stdInputform = true;
                this.toolsform = true;
                this.globalEmittersService.isCalculationHappen.next(true);
                this.ngxUiLoaderService.stop();
            } else if (this.calculationType == CalculationType.EngineeredJoint) {
                this.dataSvc.calculationData = this.calculationResult;
                this.engJointInput = this.dataSvc.calculationData.input;
                this.toolsData = this.dataSvc.calculationData.output?.tools;

                this.enggJointform = true;
            }
            this.isInitialFormLoad = false;
            this.isRedirect = 'true';
            this.tighteningform = true;

            this.toolsform = true;
            this.ngxUiLoaderService.stop();
            this.globalEmittersService.isCalculationHappen.next(true); // * this is used for tools component to display conditional based warning
            this.diagramInfo = new DiagramDataModel();
            this.diagramInfo.isEditable = true;
        } else {
            this.diagramInfo = new DiagramDataModel();
            this.isRedirect = 'false';
            if (this.calculationType == CalculationType.StandardFlange) {
                this.stdFlangeInput = new InputGroup();
            } else if (this.calculationType == CalculationType.CustomFlange) {
                // this.diagramInfo = new DiagramDataModel();
                this.diagramInfo.isEditable = true;
                this.customFlangeInput = new InputGroup();
                this.customFlangeInput.dimensionOverrides = new DimensionOverridesInput();
            } else if (this.calculationType == CalculationType.Clamp) {
                this.globalEmittersService.isCalculationHappen.next(false);
                this.clampInput = new InputGroup();
                this.dataSvc.calculationData = null;
            } else if (this.calculationType == CalculationType.EngineeredJoint) {
                this.engJointInput = new InputGroup();
                this.dataSvc.calculationData = null;
                this.globalEmittersService.isCalculationHappen.next(false);
            }
            this.dataSvc.calculationData = null;
            this.globalEmittersService.isCalculationHappen.next(false); // * this is used for tools component to display conditional based warning
        }

        this.globalEmittersService.processInfoForm.subscribe((res) => {
            this.processInfoForm = res;
            if (this.processInfoForm) {
                this.setValidity();
            }
        });
        this.globalEmittersService.standardInputForm.subscribe((res) => {
            this.standardInputForm = res;
            if (this.standardInputForm) {
                this.setValidity();
            }
        });
        this.globalEmittersService.tighteningProcedureForm.subscribe((res) => {
            this.tighteningProcedureForm = res;
            if (this.tighteningProcedureForm) {
                this.setValidity();
            }
        });
        this.globalEmittersService.toolsFormGroup.subscribe((res) => {
            this.toolsFormGroup = res;
            if (this.toolsFormGroup) {
                this.setValidity();
            }
        });
        this.globalEmittersService.customInputForm.subscribe((res) => {
            this.customInputForm = res;
            if (this.customInputForm) {
                this.setValidity();
            }
        });
        this.globalEmittersService.clampInputFormGroup.subscribe((res) => {
            this.clampInputFormGroup = res;
        });
        this.globalEmittersService.engineerJointIFormGroup.subscribe((res) => {
            this.engineerJointInputFormGroup = res;
        });
    }

    closeClick() {
        this.ngbActiveModal.close(true);
    }

    diagramDataHandler(diagramInfo: DiagramInfo) {
        // this.diagramInfo.isDiagramsAdded = true;
        if (this.calculationType == CalculationType.StandardFlange) {
            switch (diagramInfo.diagramType || diagramInfo.flangeTypeId) {
                case 'Flange':
                    this.diagramInfo = new DiagramDataModel();
                    if (diagramInfo.diagramId || diagramInfo.flangeTypeId) {
                        this.diagramInfo.isDiagramsAdded = true;
                        this.diagramInfo.flange = diagramInfo;
                    } else {
                        this.diagramInfo.flange = null;
                    }
                    break;
                case 'Flange Facing':
                    if (diagramInfo.diagramId || diagramInfo.flangeFacingTypeId) {
                        this.diagramInfo.flangeFacing = diagramInfo;
                        this.diagramInfo.isDiagramsAdded = true;
                    } else {
                        this.diagramInfo.flangeFacing = null;
                    }
                    break;
                case 'Gasket':
                    if (diagramInfo.diagramId || diagramInfo.gasketTypeId) {
                        this.diagramInfo.gasket = diagramInfo;
                    } else {
                        this.diagramInfo.gasket = null;
                    }
                    break;
                case 'Bolt Setting':
                    this.diagramInfo.boltSettingsName = diagramInfo.name;
                    this.diagramInfo.torqueSequenceName = undefined;
                    this.diagramInfo.isDiagramsAdded = true;
                    break;
                case 'Torque Sequence':
                    if (this.stdFlangeInput.others.tighteningMethod == TighteningMethod.Torque) {
                        if (diagramInfo.noOfBolts <= 0) {
                            diagramInfo.noOfBolts = this.stdFlangeInput.others.boltQuantity;
                        }
                        if (diagramInfo.noOfBolts !== undefined && diagramInfo.noOfBolts !== null) {
                            this.diagramInfo.torqueSequenceName = diagramInfo.noOfBolts + 'Hole';
                            this.diagramInfo.isDiagramsAdded = true;
                        } else {
                            this.diagramInfo.torqueSequenceName = undefined;
                        }
                        this.diagramInfo.boltSettingsName = undefined;
                    }
                    break;
                case 'Tool Diagram':
                    this.diagramInfo.tool = diagramInfo;
                    this.diagramInfo.isDiagramsAdded = true;
                    break;
                case 'Tool Image':
                    this.diagramInfo.toolImage = diagramInfo;
                    this.diagramInfo.isDiagramsAdded = true;
                    break;
            }
            if (this.diagramInfo) {
                this.globalEmittersService.diagramInfo.next(this.diagramInfo);
            } else {
                this.globalEmittersService.diagramInfo.next(null);
            }
        } else if (this.calculationType == CalculationType.CustomFlange) {
            switch (diagramInfo.diagramType) {
                case 'Flange':
                    // this.diagramInfo=new DiagramDataModel;
                    this.diagramInfo.isEditable = true;
                    if (diagramInfo.diagramId.length || diagramInfo.flangeTypeId) {
                        this.diagramInfo.isDiagramsAdded = true;

                        this.diagramInfo.flange = diagramInfo;
                    } else {
                        this.diagramInfo.flange = null;
                    }
                    break;
                case 'Flange Facing':
                    if (diagramInfo.diagramId.length || diagramInfo.flangeFacingTypeId) {
                        this.diagramInfo.isDiagramsAdded = true;
                        this.diagramInfo.flangeFacing = diagramInfo;
                    } else {
                        this.diagramInfo.flangeFacing = null;
                    }
                    break;
                case 'Gasket':
                    if (diagramInfo.diagramId.length || diagramInfo.gasketTypeId) this.diagramInfo.isDiagramsAdded = true;
                    this.diagramInfo.gasket = diagramInfo;
                    break;
                case 'Bolt Setting':
                    if (diagramInfo?.name) {
                        this.diagramInfo.isDiagramsAdded = true;
                        this.diagramInfo.boltSettingsName = diagramInfo.name;
                        this.diagramInfo.torqueSequenceName = undefined;
                    } else {
                        this.diagramInfo.boltSettingsName = undefined;
                        this.diagramInfo.torqueSequenceName = undefined;
                        // this.diagramInfo.isDiagramsAdded = false;
                    }
                    break;
                case 'Torque Sequence':
                    if (this.customFlangeInput.others.tighteningMethod == TighteningMethod.Torque) {
                        if (diagramInfo.noOfBolts <= 0) {
                            diagramInfo.noOfBolts = this.customFlangeInput.others.boltQuantity;
                        }
                        if (diagramInfo.noOfBolts !== undefined && diagramInfo.noOfBolts !== null) {
                            this.diagramInfo.isDiagramsAdded = true;
                            this.diagramInfo.torqueSequenceName = diagramInfo.noOfBolts + 'Hole';
                        }
                        this.diagramInfo.boltSettingsName = undefined;
                    }
                    break;
                case 'Tool Diagram':
                    this.diagramInfo.tool = diagramInfo;
                    this.diagramInfo.isDiagramsAdded = true;
                    break;
                case 'Tool Image':
                    this.diagramInfo.toolImage = diagramInfo;
                    this.diagramInfo.isDiagramsAdded = true;
                    break;
            }
        } else if (this.calculationType == CalculationType.Clamp) {
            switch (diagramInfo.diagramType) {
                case 'Clamp':
                    this.diagramInfo = new DiagramDataModel();
                    this.diagramInfo.isDiagramsAdded = true;
                    if (diagramInfo.diagramId || diagramInfo.pipesizeId) {
                        this.diagramInfo.clamp = diagramInfo;
                    } else {
                        this.diagramInfo.clamp = null;
                    }
                    break;
                case 'Tool Image':
                    this.diagramInfo.toolImage = diagramInfo;
                    break;
                case 'Tool Diagram':
                    this.diagramInfo.tool = diagramInfo;
                    break;
            }
        } else if (this.calculationType == CalculationType.EngineeredJoint) {
            switch (diagramInfo.diagramType) {
                case 'EngineeredJoint':
                    this.diagramInfo.isDiagramsAdded = true;
                    this.diagramInfo.engineeredJoint = diagramInfo;
                    break;
                case 'Tool Image':
                    this.diagramInfo.toolImage = diagramInfo;
                    break;
                case 'Tool Diagram':
                    this.diagramInfo.tool = diagramInfo;
                    break;
            }
        }
    }

    diagramControlDataHandler(controlData: ControlData) {
        if (this.calculationType == CalculationType.StandardFlange) {
            switch (controlData.controlName) {
                case 'flangeBoltHoleDiameter':
                    this.stdFlangeInput.dimensionOverrides.flangeBoltHoleDiameter = controlData.controlValue;
                    break;
                case 'flangeHeight':
                    this.stdFlangeInput.dimensionOverrides.flangeHeight = controlData.controlValue;
                    break;
                case 'flangeHubDiameter':
                    this.stdFlangeInput.dimensionOverrides.flangeHubDiameter = controlData.controlValue;
                    break;
                case 'flangeNeckOD':
                    this.stdFlangeInput.dimensionOverrides.flangeNeckOD = controlData.controlValue;
                    break;
                case 'flangeOD':
                    this.stdFlangeInput.dimensionOverrides.flangeOD = controlData.controlValue;
                    break;
                case 'flangePCD':
                    this.stdFlangeInput.dimensionOverrides.flangePCD = controlData.controlValue;
                    break;
                case 'flangeThickness':
                    this.stdFlangeInput.dimensionOverrides.flangeThickness = controlData.controlValue;
                    break;
                case 'grooveDepth':
                    this.stdFlangeInput.dimensionOverrides.grooveDepth = controlData.controlValue;
                    break;
                case 'outerRFOD':
                    this.stdFlangeInput.dimensionOverrides.outerRFOD = controlData.controlValue;
                    break;
                case 'pitchDiameter':
                    this.stdFlangeInput.dimensionOverrides.pitchDiameter = controlData.controlValue;
                    break;
                case 'reducedAreaBolting':
                    this.stdFlangeInput.dimensionOverrides.reducedAreaBolting = controlData.controlValue;
                    break;
                case 'rFDepth':
                    this.stdFlangeInput.dimensionOverrides.rFDepth = controlData.controlValue;
                    break;
                case 'rFID':
                    this.stdFlangeInput.dimensionOverrides.rFID = controlData.controlValue;
                    break;
                case 'rFOD':
                    this.stdFlangeInput.dimensionOverrides.rFOD = controlData.controlValue;
                    break;
                case 'rFThickness':
                    this.stdFlangeInput.dimensionOverrides.rFThickness = controlData.controlValue;
                    break;
                case 'gasketHeight':
                    this.stdFlangeInput.dimensionOverrides.gasketHeight = controlData.controlValue;
                    break;
                case 'gasketID':
                    this.stdFlangeInput.dimensionOverrides.gasketID = controlData.controlValue;
                    break;
                case 'gasketOD':
                    this.stdFlangeInput.dimensionOverrides.gasketOD = controlData.controlValue;
                    break;
                case 'gasketPitchDiameter':
                    this.stdFlangeInput.dimensionOverrides.gasketPitchDiameter = controlData.controlValue;
                    break;
                case 'gasketRingID':
                    this.stdFlangeInput.dimensionOverrides.gasketRingID = controlData.controlValue;
                    break;
                case 'gasketRingOD':
                    this.stdFlangeInput.dimensionOverrides.gasketRingOD = controlData.controlValue;
                    break;
                case 'gasketWidth':
                    this.stdFlangeInput.dimensionOverrides.gasketWidth = controlData.controlValue;
                    break;
                case 'gasketDegrees':
                    this.stdFlangeInput.dimensionOverrides.gasketDegrees = controlData.controlValue;
                    break;
                case 'gasketThickness':
                    this.stdFlangeInput.dimensionOverrides.gasketThickness = controlData.controlValue;
                    break;
                case 'widthOfFlat':
                    this.stdFlangeInput.dimensionOverrides.widthOfFlat = controlData.controlValue;
                    break;
            }
        } else if (this.calculationType == CalculationType.CustomFlange) {
            switch (controlData.controlName) {
                case 'flangeBoltHoleDiameter':
                    this.customFlangeInput.dimensionOverrides.flangeBoltHoleDiameter = controlData.controlValue;
                    this.isOverrideFlangeValid = controlData.isFormValid;
                    break;
                case 'flangeHeight':
                    this.customFlangeInput.dimensionOverrides.flangeHeight = controlData.controlValue;
                    this.isOverrideFlangeValid = controlData.isFormValid;
                    break;
                case 'flangeHubDiameter':
                    this.customFlangeInput.dimensionOverrides.flangeHubDiameter = controlData.controlValue;
                    this.isOverrideFlangeValid = controlData.isFormValid;
                    break;
                case 'flangeNeckOD':
                    this.customFlangeInput.dimensionOverrides.flangeNeckOD = controlData.controlValue;
                    this.isOverrideFlangeValid = controlData.isFormValid;
                    break;
                case 'flangeOD':
                    this.customFlangeInput.dimensionOverrides.flangeOD = controlData.controlValue;
                    this.isOverrideFlangeValid = controlData.isFormValid;
                    break;
                case 'flangePCD':
                    this.customFlangeInput.dimensionOverrides.flangePCD = controlData.controlValue;
                    this.isOverrideFlangeValid = controlData.isFormValid;
                    break;
                case 'flangeThickness':
                    this.customFlangeInput.dimensionOverrides.flangeThickness = controlData.controlValue;
                    this.isOverrideFlangeValid = controlData.isFormValid;
                    break;
                case 'flangeSocketID':
                    this.customFlangeInput.dimensionOverrides.flangeSocketID = controlData.controlValue;
                    this.isOverrideFlangeValid = controlData.isFormValid;
                    break;
                case 'flangeID':
                    this.customFlangeInput.dimensionOverrides.flangeID = controlData.controlValue;
                    this.isOverrideFlangeValid = controlData.isFormValid;
                    break;

                case 'grooveDepth':
                    this.customFlangeInput.dimensionOverrides.grooveDepth = controlData.controlValue;
                    this.isOverrideFlangeFacingValid = controlData.isFormValid;
                    break;
                case 'outerRFOD':
                    this.customFlangeInput.dimensionOverrides.outerRFOD = controlData.controlValue;
                    this.isOverrideFlangeFacingValid = controlData.isFormValid;
                    break;
                case 'pitchDiameter':
                    this.customFlangeInput.dimensionOverrides.pitchDiameter = controlData.controlValue;
                    this.isOverrideFlangeFacingValid = controlData.isFormValid;
                    break;
                case 'reducedAreaBolting':
                    this.customFlangeInput.dimensionOverrides.reducedAreaBolting = controlData.controlValue;
                    this.isOverrideFlangeFacingValid = controlData.isFormValid;
                    break;
                case 'rFDepth':
                    this.customFlangeInput.dimensionOverrides.rFDepth = controlData.controlValue;
                    this.isOverrideFlangeFacingValid = controlData.isFormValid;
                    break;
                case 'rFID':
                    this.customFlangeInput.dimensionOverrides.rFID = controlData.controlValue;
                    this.isOverrideFlangeFacingValid = controlData.isFormValid;
                    break;
                case 'rFOD':
                    this.customFlangeInput.dimensionOverrides.rFOD = controlData.controlValue;
                    this.isOverrideFlangeFacingValid = controlData.isFormValid;
                    break;
                case 'rFThickness':
                    this.customFlangeInput.dimensionOverrides.rFThickness = controlData.controlValue;
                    this.isOverrideFlangeFacingValid = controlData.isFormValid;
                    break;

                case 'gasketHeight':
                    this.customFlangeInput.dimensionOverrides.gasketHeight = controlData.controlValue;
                    this.isOverrideGasketValid = controlData.isFormValid;
                    break;
                case 'gasketID':
                    this.customFlangeInput.dimensionOverrides.gasketID = controlData.controlValue;
                    this.isOverrideGasketValid = controlData.isFormValid;
                    break;
                case 'gasketOD':
                    this.customFlangeInput.dimensionOverrides.gasketOD = controlData.controlValue;
                    this.isOverrideGasketValid = controlData.isFormValid;
                    break;
                case 'gasketPitchDiameter':
                    this.customFlangeInput.dimensionOverrides.gasketPitchDiameter = controlData.controlValue;
                    this.isOverrideGasketValid = controlData.isFormValid;
                    break;
                case 'gasketRingID':
                    this.customFlangeInput.dimensionOverrides.gasketRingID = controlData.controlValue;
                    this.isOverrideGasketValid = controlData.isFormValid;
                    break;
                case 'gasketRingOD':
                    this.customFlangeInput.dimensionOverrides.gasketRingOD = controlData.controlValue;
                    this.isOverrideGasketValid = controlData.isFormValid;
                    break;
                case 'gasketWidth':
                    this.customFlangeInput.dimensionOverrides.gasketWidth = controlData.controlValue;
                    this.isOverrideGasketValid = controlData.isFormValid;
                    break;
                case 'gasketDegrees':
                    this.customFlangeInput.dimensionOverrides.gasketDegrees = controlData.controlValue;
                    this.isOverrideGasketValid = controlData.isFormValid;
                    break;
                case 'gasketThickness':
                    this.customFlangeInput.dimensionOverrides.gasketThickness = controlData.controlValue;
                    this.isOverrideGasketValid = controlData.isFormValid;
                    break;
                case 'widthOfFlat':
                    this.customFlangeInput.dimensionOverrides.widthOfFlat = controlData.controlValue;
                    this.isOverrideGasketValid = controlData.isFormValid;
                    break;
            }
            this.setValidity();
        }
    }

    tighteningDataHandler(tighteningData: TighteningData) {
        if (tighteningData.isDataValid) {
            if (this.calculationType == CalculationType.StandardFlange) {
                this.stdFlangeInput.others.tighteningMethod = tighteningData.tighteningMethod;
                this.stdFlangeInput.others.breakout = tighteningData.breakout;
                this.stdFlangeInput.others.percentageCover = tighteningData.percentageCover;
                this.stdFlangeInput.others.lubricantMode = tighteningData.lubricantMode;
                this.stdFlangeInput.recordId.lubricantId = tighteningData.lubricantId;
                this.stdFlangeInput.calculationOverrides.kFactor = tighteningData.kFactor;
                this.tighteningform = false;
                this.stdInputform = true;
            } else if (this.calculationType == CalculationType.CustomFlange) {
                this.customFlangeInput.others.tighteningMethod = tighteningData.tighteningMethod;
                this.customFlangeInput.others.breakout = tighteningData.breakout;
                this.customFlangeInput.others.percentageCover = tighteningData.percentageCover;
                this.customFlangeInput.others.lubricantMode = tighteningData.lubricantMode;
                this.customFlangeInput.recordId.lubricantId = tighteningData.lubricantId;
                this.customFlangeInput.calculationOverrides.kFactor = tighteningData.kFactor;
                this.tighteningform = false;
                this.customForm = true;
            } else if (this.calculationType == CalculationType.Clamp) {
                this.clampInput.others.tighteningMethod = tighteningData.tighteningMethod;
                this.clampInput.others.breakout = tighteningData.breakout;
                this.clampInput.others.percentageCover = tighteningData.percentageCover;
                this.clampInput.others.lubricantMode = tighteningData.lubricantMode;
                this.clampInput.recordId.lubricantId = tighteningData.lubricantId;
                this.clampInput.calculationOverrides.kFactor = tighteningData.kFactor;
                this.isTighteningInputValid = true;
                this.tighteningform = false;
            } else if (this.calculationType == CalculationType.EngineeredJoint) {
                this.engJointInput.others.tighteningMethod = tighteningData.tighteningMethod;
                this.engJointInput.others.breakout = tighteningData.breakout;
                this.engJointInput.others.percentageCover = tighteningData.percentageCover;
                this.engJointInput.others.lubricantMode = tighteningData.lubricantMode;
                this.engJointInput.recordId.lubricantId = tighteningData.lubricantId;
                this.engJointInput.calculationOverrides.kFactor = tighteningData.kFactor;
                this.isTighteningInputValid = true;
            }

            this.isTighteningInputValid = true;
            this.setValidity();
        } else {
            this.isTighteningInputValid = false;
        }
    }

    setValidity() {
        if (this.calculationType == CalculationType.StandardFlange) {
            if (this.isTighteningInputValid && this.isStdInputValid && this.isProcessInfoInputValid) {
                this.isInputValid = true;
            } else {
                this.isInputValid = false;
            }
        } else if (this.calculationType == CalculationType.CustomFlange) {
            if (
                this.isTighteningInputValid &&
                this.isCustomInputValid &&
                this.isProcessInfoInputValid &&
                this.isOverrideFlangeValid &&
                this.isOverrideFlangeFacingValid &&
                this.isOverrideGasketValid
            ) {
                this.isInputValid = true;
            } else {
                this.isInputValid = false;
            }
        } else if (this.calculationType == CalculationType.Clamp) {
            if (this.isTighteningInputValid && this.isInputValid) {
                this.isInputValid = true;
            } else {
                this.isInputValid = false;
            }
        } else if (this.calculationType == CalculationType.EngineeredJoint) {
            if (this.isTighteningInputValid && this.isEngJointInputValid) {
                this.isInputValid = true;
            } else {
                this.isInputValid = false;
            }
        }
    }

    processInfoDataHandler(processInfoData: ProcessInfoData) {
        if (this.calculationType == CalculationType.StandardFlange) {
            if (processInfoData.isDataValid) {
                this.stdFlangeInput.calculationOverrides.operatingTemperature = processInfoData.operatingTemperature;
                this.stdFlangeInput.calculationOverrides.operatingPressure = processInfoData.operatingPressure;
                this.stdFlangeInput.calculationOverrides.testPressure = processInfoData.testPressure;
                this.isProcessInfoInputValid = true;
                this.editpanel_3 = true;
                this.processform = false;
                this.toolsform = true;
                this.setValidity();
            } else {
                this.isProcessInfoInputValid = false;
            }
        } else if (this.calculationType == CalculationType.CustomFlange) {
            if (processInfoData.isDataValid) {
                this.customFlangeInput.calculationOverrides.operatingTemperature = processInfoData.operatingTemperature;
                this.customFlangeInput.calculationOverrides.operatingPressure = processInfoData.operatingPressure;
                this.customFlangeInput.calculationOverrides.testPressure = processInfoData.testPressure;
                this.isProcessInfoInputValid = true;
            } else {
                this.isProcessInfoInputValid = false;
            }
            if (!this.editpanel_3) {
            }
            this.editpanel_3 = true;
            this.processform = false;
            this.setValidity();
        } else if (this.calculationType == CalculationType.EngineeredJoint) {
            this.engJointInput.calculationOverrides.operatingTemperature = processInfoData.operatingTemperature;
            this.engJointInput.calculationOverrides.operatingPressure = processInfoData.operatingPressure;
            this.engJointInput.calculationOverrides.testPressure = processInfoData.testPressure;
            if (this.isTighteningInputValid && this.isEngJointInputValid) {
                this.engJointInput.calculationOverrides.distanceToNearestObstruction = '1000 mm';
                this.invokeCalculate(this.engJointInput)
                    .then((res) => {
                        this.ngxUiLoaderService.stop();
                        this.iceapi.calculationRes.next(true);
                    })
                    .catch((err) => {
                        this.ngxUiLoaderService.stop();
                    });
            }
        }
    }

    StdDataHandler(stdInputData: StdInputData) {
        if (stdInputData.isDataValid) {
            this.stdFlangeInput.recordId.standardId = stdInputData.standardId;
            this.stdFlangeInput.recordId.pressureClassId = stdInputData.pressureClassId;
            this.stdFlangeInput.recordId.pipeSizeId = stdInputData.pipeSizeId;
            this.stdFlangeInput.recordId.flangeTypeId1 = stdInputData.flangeTypeId1;
            this.stdFlangeInput.recordId.flangeFacingTypeId = stdInputData.flangeFacingTypeId;
            this.stdFlangeInput.recordId.flangeMaterialId1 = stdInputData.flangeMaterialId1;
            this.stdFlangeInput.recordId.gasketId = stdInputData.gasketId;
            this.stdFlangeInput.recordId.boltMaterialId = stdInputData.boltMaterialId;

            this.stdFlangeInput.recordId.boltMaterialAliasId =
                stdInputData.boltMaterialAliasId == undefined || stdInputData.boltMaterialAliasId == null || stdInputData.boltMaterialAliasId == ''
                    ? null
                    : stdInputData.boltMaterialAliasId;
            this.stdFlangeInput.recordId.flangeMaterialAliasId1 =
                stdInputData.flangeMaterialAliasId1 == undefined || stdInputData.flangeMaterialAliasId1 == null || stdInputData.flangeMaterialAliasId1 == ''
                    ? null
                    : stdInputData.flangeMaterialAliasId1;
            this.stdFlangeInput.recordId.flangeMaterialAliasId2 =
                stdInputData.flangeMaterialAliasId2 == undefined || stdInputData.flangeMaterialAliasId2 == null || stdInputData.flangeMaterialAliasId2 == ''
                    ? null
                    : stdInputData.flangeMaterialAliasId2;
            this.stdFlangeInput.recordId.gasketAliasId =
                stdInputData.gasketAliasId == undefined || stdInputData.gasketAliasId == null || stdInputData.gasketAliasId == ''
                    ? null
                    : stdInputData.gasketAliasId;

            this.stdFlangeInput.recordId.flangeTypeId2 = stdInputData.flangeTypeId2;
            this.stdFlangeInput.recordId.pipeScheduleId = stdInputData.pipeScheduleId;
            this.stdFlangeInput.recordId.additionalThicknessId = stdInputData.additionalThicknessId;
            this.stdFlangeInput.recordId.washerDimensionId = stdInputData.washerThickness;

            this.stdFlangeInput.others.tighteningSpecification = stdInputData.tighteningSpecification;
            this.stdFlangeInput.others.tighteningSpecificationInput = stdInputData.tighteningSpecificationInput;
            this.stdFlangeInput.others.boltType = stdInputData.boltType;
            this.stdFlangeInput.calculationOverrides.additionalThickness = stdInputData.additionalThickness;

            this.stdFlangeInput.recordId.boltDimensionId = stdInputData.boltDimensionId;
            this.stdFlangeInput.others.threadType = stdInputData.threadType;
            this.stdFlangeInput.others.boltQuantity = stdInputData.boltQuantity;
            this.stdFlangeInput.recordId.nutDimensionId = stdInputData.nutDimensionId;
            this.stdFlangeInput.calculationOverrides.minimumBoltDiameter = stdInputData.minimumBoltDiameter;
            this.stdFlangeInput.calculationOverrides.recommendedGasketStress = stdInputData.recommendedGasketStress;
            this.stdFlangeInput.calculationOverrides.minimumGasketStress = stdInputData.minimumGasketStress;
            this.stdFlangeInput.calculationOverrides.maximumGasketStress = stdInputData.maximumGasketStress;
            this.stdFlangeInput.calculationOverrides.y = stdInputData.y;
            this.stdFlangeInput.calculationOverrides.m = stdInputData.m;
            this.stdFlangeInput.calculationOverrides.pAdditional = stdInputData.pAdditional;
            this.isStdInputValid = true;
            this.setValidity();
        } else {
            this.isStdInputValid = false;
        }
    }

    isEditableDataHandler(isEdit: boolean) {
        this.stdFlangeInput.dimensionOverrides = isEdit ? new DimensionOverridesInput() : null;
        this.diagramInfo.isEditable = isEdit;
    }

    processInfoInputDataHandler(processInfo: ProcessInfoModel) {
        this.processInfoInput = processInfo;
    }

    overriddenFlangeHandler(event: boolean) {
        this.isOverriddenFlange = false;
    }

    btnCalculateClicked() {
        if (this.calculationType == CalculationType.StandardFlange) {
            this.stdFlangeInput.others.tighteningMethod = <any>TighteningMethod[this.tighteningProcedureForm?.get('calcMethod')?.value];
            this.globalEmittersService.refreshWarnings.next(true);

            if ((this.isInputValid || this.isRedirect == 'true') && this.processInfoForm.valid) {
                this.ngxUiLoaderService.start();
                // if (this.isOverriddenFlange) {
                //     this.stdFlangeInput.calculationType = this.isOverriddenFlange ? CalculationType.OverriddenFlange : CalculationType.StandardFlange;
                // }
                if (!this.stdFlangeInput.calculationOverrides.distanceToNearestObstruction) {
                    this.stdFlangeInput.calculationOverrides.distanceToNearestObstruction = '1000 mm';
                }

                this.invokeCalculate(this.stdFlangeInput)
                    .then((res) => {
                        this.ngxUiLoaderService.stop();
                        // this.iceapi.calculationRes.next(true);
                    })
                    .catch((error) => {
                        this.ngxUiLoaderService.stop();
                    });
            }
        } else if (this.calculationType == CalculationType.CustomFlange) {
            this.globalEmittersService.refreshWarnings.next(true);
            if (this.isInputValid || this.isRedirect == 'true') {
                this.ngxUiLoaderService.start();
                this.customFlangeInput.calculationType = CalculationType.CustomFlange;
                if (!this.customFlangeInput.calculationOverrides.distanceToNearestObstruction) {
                    this.customFlangeInput.calculationOverrides.distanceToNearestObstruction = '1000 mm';
                }

                this.invokeCalculate(this.customFlangeInput).then(
                    (res) => {
                        this.ngxUiLoaderService.stop();
                        // this.iceapi.calculationRes.next(true);
                    },
                    (err) => {
                        this.ngxUiLoaderService.stop();
                    }
                );
            }
        } else if (this.calculationType == CalculationType.Clamp) {
            this.globalEmittersService.refreshWarnings.next(true);
            if (this.isInputValid || this.isRedirect == 'true') {
                this.ngxUiLoaderService.start();
                this.clampInput.calculationType = CalculationType.Clamp;
                if (!this.clampInput.calculationOverrides.distanceToNearestObstruction) {
                    this.clampInput.calculationOverrides.distanceToNearestObstruction = '1000 mm';
                }

                this.invokeCalculate(this.clampInput)
                    .then((res) => {
                        this.ngxUiLoaderService.stop();
                        // this.iceapi.calculationRes.next(true);
                    })
                    .catch((error) => {
                        this.ngxUiLoaderService.stop();
                    });
            }
        } else if (this.calculationType == CalculationType.EngineeredJoint) {
            this.globalEmittersService.refreshWarnings.next(true);
            if (this.isInputValid || this.isRedirect == 'true') {
                this.ngxUiLoaderService.start();
                this.engJointInput.calculationType = CalculationType.EngineeredJoint;
                if (!this.engJointInput.calculationOverrides.distanceToNearestObstruction) {
                    this.engJointInput.calculationOverrides.distanceToNearestObstruction = '1000 mm';
                }

                this.invokeCalculate(this.engJointInput)
                    .then((res) => {
                        this.ngxUiLoaderService.stop();
                    })
                    .catch((err) => {
                        this.ngxUiLoaderService.stop();
                    });
            }
        }
    }

    async invokeCalculate(inputGroup: InputGroup) {
        if (this.calculationType == CalculationType.Clamp) {
            await this.iceapi
                .postCalculateClamp(inputGroup, true)
                .toPromise()
                .then((res) => {
                    if (res.success === true) {
                        if (res.response.calculationSucceeded || (!res.response.calculationSucceeded && res.response?.output?.general?.warnings?.length > 0)) {
                            this.calculationResult = res.response;
                            this.calculationResult.diagramInfo = this.diagramInfo;
                            //To update  flange details tab
                            this.globalEmittersService.calculationResult.next(this.calculationResult);
                            if (
                                !res.response.calculationSucceeded &&
                                res.response?.output?.general?.warnings?.length > 0 &&
                                res.response?.output?.general?.warnings[0].severity == 1
                            )
                                this.customToastService.errorToast('Unable to perform calculation!!', 'Error');
                            else this.customToastService.successToast('Calculation Success', 'Success');

                            let calculationResultString = JSON.stringify(this.calculationResult).replace(/ "'/g, " $Inch$'").replace(/ ""/g, ' $Inch$"'); //To remove double quote issue
                            this.globalEmittersService.setSelectedTab.next(1);
                            //To save joint calculation in plant manager component
                            let result = {
                                calculationResultString: calculationResultString,
                                calculationResult: this.calculationResult,
                            };
                            this.CalculationResultString.emit(result);

                            this.ngbActiveModal.close();
                            this.calculationResult = res.response;

                            this.globalEmittersService.isCalculationHappen.next(true); // * this is used for tools component to display conditional based warning
                            this.globalEmittersService.ShowFlangeDetailsTab.next(true);
                            this.toolsData = this.calculationResult.output.tools;
                            if (this.toolsData?.length > 0) this.ShowToolSelection();
                            // else {
                            //     let calculationResultString = JSON.stringify(this.calculationResult).replace(/ "'/g, " $Inch$'").replace(/ ""/g, ' $Inch$"'); //To remove double quote issue
                            //     let result = {
                            //         calculationResultString: calculationResultString,
                            //         calculationResult: this.calculationResult,
                            //     };
                            //     this.CalculationResultString.emit(result);
                            // }
                        } else {
                            this.globalEmittersService.isCalculationHappen.next(false); // * this is used for tools component to display conditional based warning
                            this.globalEmittersService.ShowFlangeDetailsTab.next(false);
                            this.user_utility.errorModelPopup('Calculation Failed!!');
                        }

                        this.PlantmanagerService.updateFormAfterCalculation.next(true); ////set schemForm in dynamic component mark as dirty to update after recalculate
                    } else {
                        this.globalEmittersService.isCalculationHappen.next(false);
                        this.globalEmittersService.ShowFlangeDetailsTab.next(false);
                        this.user_utility.errorModelPopup(res.message);
                    }
                })
                .catch((error) => {
                    this.ngxUiLoaderService.stop();
                });
        } else if (this.calculationType == CalculationType.EngineeredJoint) {
            await this.iceapi
                .postCalculateEngineeredJoint(inputGroup, true)
                .toPromise()
                .then((res) => {
                    if (res.success === true) {
                        if (res.response.calculationSucceeded || (!res.response.calculationSucceeded && res.response?.output?.general?.warnings?.length > 0)) {
                            this.calculationResult = res.response;
                            this.calculationResult.diagramInfo = this.diagramInfo;
                            //To update  flange details tab
                            let calculationResult: any = this.calculationResult;
                            this.globalEmittersService.calculationResult.next(calculationResult);
                            if (
                                !res.response.calculationSucceeded &&
                                res.response?.output?.general?.warnings?.length > 0 &&
                                res.response?.output?.general?.warnings[0].severity == 1
                            )
                                this.customToastService.errorToast('Unable to perform calculation!!', 'Error');
                            else this.customToastService.successToast('Calculation Success', 'Success');

                            let calculationResultString = JSON.stringify(this.calculationResult).replace(/ "'/g, " $Inch$'").replace(/ ""/g, ' $Inch$"'); //To remove double quote issue
                            this.globalEmittersService.setSelectedTab.next(1);
                            //To save joint calculation in plant manager component
                            let result = {
                                calculationResultString: calculationResultString,
                                calculationResult: this.calculationResult,
                            };
                            this.CalculationResultString.emit(result);
                            this.calculationResult = res.response;

                            this.globalEmittersService.isCalculationHappen.next(true); // * this is used for tools component to display conditional based warning
                            this.globalEmittersService.ShowFlangeDetailsTab.next(true);
                            this.toolsData = this.calculationResult.output.tools;
                            if (this.toolsData?.length > 0) this.ShowToolSelection();
                        } else {
                            this.globalEmittersService.isCalculationHappen.next(false); // * this is used for tools component to display conditional based warning
                            this.globalEmittersService.ShowFlangeDetailsTab.next(false);
                            this.user_utility.errorModelPopup('Calculation Failed!!');
                        }
                        this.ngbActiveModal.close();

                        this.PlantmanagerService.updateFormAfterCalculation.next(true);
                    } else {
                        this.globalEmittersService.isCalculationHappen.next(false);
                        this.globalEmittersService.ShowFlangeDetailsTab.next(false);
                        this.user_utility.errorModelPopup(res.message);
                    }
                    this.cd.detectChanges();
                })
                .catch((error) => {
                    this.ngxUiLoaderService.stop();
                });
        } else {
            await this.iceapi
                .postCalculateStandardFlange(inputGroup, true)
                .toPromise()
                .then(
                    (res) => {
                        if (res.success === true) {
                            if (
                                res.response.calculationSucceeded ||
                                (!res.response.calculationSucceeded && res.response?.output?.general?.warnings?.length > 0)
                            ) {
                                this.calculationResult = res.response;
                                this.calculationResult.diagramInfo = this.diagramInfo;
                                //To update  flange details tab
                                let calculationResult: any = this.calculationResult;
                                this.globalEmittersService.calculationResult.next(calculationResult);
                                if (
                                    !res.response.calculationSucceeded &&
                                    res.response?.output?.general?.warnings?.length > 0 &&
                                    res.response?.output?.general?.warnings[0].severity == 1
                                )
                                    this.customToastService.errorToast('Unable to perform calculation!!', 'Error');
                                else this.customToastService.successToast('Calculation Success', 'Success');

                                let calculationResultString = JSON.stringify(this.calculationResult).replace(/ "'/g, " $Inch$'").replace(/ ""/g, ' $Inch$"'); //To remove double quote issue
                                //To save joint calculation in plant manager component
                                this.globalEmittersService.setSelectedTab.next(1);
                                let result = {
                                    calculationResultString: calculationResultString,
                                    calculationResult: this.calculationResult,
                                };
                                this.CalculationResultString.emit(result);
                                this.calculationResult = res.response;

                                this.globalEmittersService.isCalculationHappen.next(true); // * this is used for tools component to display conditional based warning
                                this.globalEmittersService.ShowFlangeDetailsTab.next(true);
                                this.toolsData = this.calculationResult.output.tools;
                                if (this.toolsData?.length > 0) this.ShowToolSelection();
                            } else {
                                this.globalEmittersService.isCalculationHappen.next(false); // * this is used for tools component to display conditional based warning
                                this.globalEmittersService.ShowFlangeDetailsTab.next(false);
                                this.user_utility.errorModelPopup('Calculation Failed!!');
                            }
                            this.ngbActiveModal.close();

                            this.PlantmanagerService.updateFormAfterCalculation.next(true);
                            this.globalEmittersService.setSelectedTab.next(1);
                            //this.cd.markForCheck();
                        } else {
                            this.globalEmittersService.isCalculationHappen.next(false);
                            this.globalEmittersService.ShowFlangeDetailsTab.next(false);
                            this.user_utility.errorModelPopup(res.message);
                        }
                        this.cd.detectChanges();
                    },
                    (err) => {
                        this.globalEmittersService.isCalculationHappen.next(false);
                        this.globalEmittersService.ShowFlangeDetailsTab.next(false);
                        this.user_utility.errorModelPopup(err);
                    }
                );
        }
    }

    customFlangeDataHandler(customInput: StdInputData) {
        // if (this.isRedirect != "true") {
        if (customInput.isDataValid) {
            // this.customFlangeInput.dimensionOverrides = new DimensionOverridesInput();
            this.customFlangeInput.recordId.flangeTypeId1 = customInput.flangeTypeId1;
            this.customFlangeInput.recordId.flangeTypeId2 = customInput.flangeTypeId1;
            this.customFlangeInput.recordId.flangeFacingTypeId = customInput.flangeFacingTypeId;
            this.customFlangeInput.recordId.flangeMaterialId1 = customInput.flangeMaterialId1;
            this.customFlangeInput.recordId.gasketId = customInput.gasketId;
            this.customFlangeInput.recordId.boltMaterialId = customInput.boltMaterialId;
            this.customFlangeInput.recordId.additionalThicknessId = customInput.additionalThicknessId;
            this.customFlangeInput.recordId.boltDimensionId = customInput.boltDimensionId;
            this.customFlangeInput.recordId.nutDimensionId = customInput.nutDimensionId;

            this.customFlangeInput.others.tighteningSpecification = customInput.tighteningSpecification;
            this.customFlangeInput.others.tighteningSpecificationInput = customInput.tighteningSpecificationInput;
            this.customFlangeInput.others.boltType = customInput.boltType;
            this.customFlangeInput.recordId.washerDimensionId = customInput.washerThickness;
            this.customFlangeInput.others.boltQuantity = customInput.boltQuantity;
            this.customFlangeInput.others.threadType = customInput.threadType;

            this.customFlangeInput.calculationOverrides.standard = customInput.customStandardName;
            this.customFlangeInput.calculationOverrides.pipeSize = customInput.customPipeSizeName;
            this.customFlangeInput.calculationOverrides.pipeSchedule = customInput.customPipeScheduleName;
            this.customFlangeInput.calculationOverrides.additionalThickness = customInput.additionalThickness;
            this.customFlangeInput.calculationOverrides.minimumBoltDiameter = customInput.minimumBoltDiameter;
            this.customFlangeInput.calculationOverrides.recommendedGasketStress = customInput.recommendedGasketStress;
            this.customFlangeInput.calculationOverrides.minimumGasketStress = customInput.minimumGasketStress;
            this.customFlangeInput.calculationOverrides.maximumGasketStress = customInput.maximumGasketStress;
            this.customFlangeInput.calculationOverrides.y = customInput.y;
            this.customFlangeInput.calculationOverrides.m = customInput.m;

            this.customFlangeInput.recordId.boltMaterialAliasId =
                customInput.boltMaterialAliasId == undefined || customInput.boltMaterialAliasId == null || customInput.boltMaterialAliasId == ''
                    ? null
                    : customInput.boltMaterialAliasId;
            this.customFlangeInput.recordId.flangeMaterialAliasId1 =
                customInput.flangeMaterialAliasId1 == undefined || customInput.flangeMaterialAliasId1 == null || customInput.flangeMaterialAliasId1 == ''
                    ? null
                    : customInput.flangeMaterialAliasId1;
            this.customFlangeInput.recordId.flangeMaterialAliasId2 =
                customInput.flangeMaterialAliasId2 == undefined || customInput.flangeMaterialAliasId2 == null || customInput.flangeMaterialAliasId2 == ''
                    ? null
                    : customInput.flangeMaterialAliasId2;
            this.customFlangeInput.recordId.gasketAliasId =
                customInput.gasketAliasId == undefined || customInput.gasketAliasId == null || customInput.gasketAliasId == ''
                    ? null
                    : customInput.gasketAliasId;

            this.isCustomInputValid = true;
        } else {
            this.isCustomInputValid = false;
        }

        this.editpanel_2 = true;
        this.customForm = false;
        this.setValidity();
    }

    disableButton() {
        if (this.calculationType == CalculationType.StandardFlange) {
            //
            if (this.standardInputForm?.invalid || this.processInfoForm?.invalid || this.tighteningProcedureForm?.invalid || this.toolsFormGroup?.invalid) {
                // || this.toolsFormGroup?.invalid
                return true;
            }
        } else if (this.calculationType == CalculationType.CustomFlange) {
            if (
                this.customInputForm?.invalid ||
                this.processInfoForm?.invalid ||
                this.tighteningProcedureForm?.invalid ||
                this.toolsFormGroup?.invalid ||
                this.isInputValid == false
            ) {
                // || this.toolsFormGroup?.invalid
                return true;
            }
        } else if (this.calculationType == CalculationType.Clamp) {
            if (this.clampInputFormGroup?.invalid || this.tighteningProcedureForm?.invalid || this.toolsFormGroup?.invalid) {
                // || this.toolsFormGroup?.invalid
                return true;
            }
        } else if (this.calculationType == CalculationType.EngineeredJoint) {
            if (this.engineerJointInputFormGroup?.invalid || this.tighteningProcedureForm?.invalid || this.toolsFormGroup?.invalid) {
                // || this.toolsFormGroup?.invalid
                return true;
            }
        } else return false;
        return false;
    }

    //For Clamp calculation
    InputsDataHandler(clampInputData: ClampInputData) {
        if (clampInputData.isDataValid) {
            this.clampInput.recordId.manufacturerId = clampInputData.manufacturerId;
            this.clampInput.recordId.boltMaterialId = clampInputData.boltMaterialId;
            this.clampInput.recordId.clampId = clampInputData.clampId;
            this.clampInput.recordId.clampMaterialId = clampInputData.clampMaterialId;
            this.clampInput.recordId.hubMaterialId = clampInputData.hubMaterialId;
            this.clampInput.recordId.pipeScheduleId = clampInputData.pipeScheduleId;
            this.clampInput.recordId.pipeSizeId = clampInputData.pipeSizeId;
            this.clampInput.recordId.sealRingMaterialId = clampInputData.sealRingMaterialId;
            this.clampInput.recordId.sealRingId = clampInputData.sealRingId;
            //this.clampInput.recordId.boltDimensionId = clampInputData.boltDimensionId     ??
            //this.clampInput.recordId.nutDimensionId = clampInputData.nutDimensionId       ??
            //adding misalignmentFactor
            this.clampInput.others.misalignmentFactor = clampInputData.misalignmentFactor;
            this.clampInput.others.boltType = clampInputData.boltType;
            this.clampInput.others.washerThickness = clampInputData.washerThickness;

            this.clampInput.recordId.boltMaterialAliasId =
                clampInputData.boltMaterialAliasId == undefined || clampInputData.boltMaterialAliasId == null || clampInputData.boltMaterialAliasId == ''
                    ? null
                    : clampInputData.boltMaterialAliasId;
            this.clampInput.recordId.flangeMaterialAliasId1 =
                clampInputData.flangeMaterialAliasId1 == undefined ||
                clampInputData.flangeMaterialAliasId1 == null ||
                clampInputData.flangeMaterialAliasId1 == ''
                    ? null
                    : clampInputData.flangeMaterialAliasId1;
            this.clampInput.recordId.flangeMaterialAliasId2 =
                clampInputData.flangeMaterialAliasId2 == undefined ||
                clampInputData.flangeMaterialAliasId2 == null ||
                clampInputData.flangeMaterialAliasId2 == ''
                    ? null
                    : clampInputData.flangeMaterialAliasId2;
            this.clampInput.recordId.gasketAliasId =
                clampInputData.gasketAliasId == undefined || clampInputData.gasketAliasId == null || clampInputData.gasketAliasId == ''
                    ? null
                    : clampInputData.gasketAliasId;

            this.isInputValid = true;
        } else {
            this.isInputValid = false;
        }
        this.editpanel_2 = true;
        this.stdInputform = false;
        this.setValidity();
    }

    engJointDataHandler(engJointInputData: EngineeredJointInputData) {
        if (engJointInputData.isDataValid) {
            this.engJointInput.others.jointConfiguration = engJointInputData.jointConfiguration;
            engJointInputData.isRedAreaBoltSelected
                ? (this.engJointInput.calculationOverrides.minimumBoltDiameter = engJointInputData.minimumBoltDiameter)
                : (this.engJointInput.calculationOverrides.minimumBoltDiameter = undefined);
            this.engJointInput.calculationOverrides.jointThickness = engJointInputData.jointThickness;
            this.engJointInput.calculationOverrides.boltHoleDiameter = engJointInputData.boltHoleDiameter;
            this.engJointInput.calculationOverrides.gasketCompThickness = engJointInputData.gasketCompThickness;

            this.engJointInput.others.threadType = engJointInputData.threadType;
            this.engJointInput.others.boltType = engJointInputData.boltType;
            this.engJointInput.others.boltQuantity = engJointInputData.boltQuantity;
            this.engJointInput.recordId.boltDimensionId = engJointInputData.boltDimensionId;
            this.engJointInput.recordId.nutDimensionId = engJointInputData.nutDimensionId;

            this.engJointInput.others.tighteningSpecification = engJointInputData.tighteningSpecification;
            this.engJointInput.others.tighteningSpecificationInput = engJointInputData.tighteningSpecificationInput;
            this.engJointInput.recordId.flangeMaterialId1 = engJointInputData.flangeMaterialId1;
            this.engJointInput.recordId.flangeMaterialId2 = engJointInputData.flangeMaterialId2;
            this.engJointInput.recordId.gasketId = engJointInputData.gasketId;
            this.engJointInput.recordId.boltMaterialId = engJointInputData.boltMaterialId;

            this.engJointInput.recordId.boltMaterialAliasId =
                engJointInputData.boltMaterialAliasId == undefined ||
                engJointInputData.boltMaterialAliasId == null ||
                engJointInputData.boltMaterialAliasId == ''
                    ? null
                    : engJointInputData.boltMaterialAliasId;
            this.engJointInput.recordId.flangeMaterialAliasId1 =
                engJointInputData.flangeMaterialAliasId1 == undefined ||
                engJointInputData.flangeMaterialAliasId1 == null ||
                engJointInputData.flangeMaterialAliasId1 == ''
                    ? null
                    : engJointInputData.flangeMaterialAliasId1;
            this.engJointInput.recordId.flangeMaterialAliasId2 =
                engJointInputData.flangeMaterialAliasId2 == undefined ||
                engJointInputData.flangeMaterialAliasId2 == null ||
                engJointInputData.flangeMaterialAliasId2 == ''
                    ? null
                    : engJointInputData.flangeMaterialAliasId2;
            this.engJointInput.recordId.gasketAliasId =
                engJointInputData.gasketAliasId == undefined || engJointInputData.gasketAliasId == null || engJointInputData.gasketAliasId == ''
                    ? null
                    : engJointInputData.gasketAliasId;

            this.isEngJointInputValid = true;
        } else {
            this.isEngJointInputValid = false;
        }
        this.editpanel_2 = true;
        this.enggJointform = false;
        this.setValidity();
    }

    toolsDataHandler(nearestObstruction: string) {
        this.engJointInput.calculationOverrides.distanceToNearestObstruction = nearestObstruction;
    }

    selectedToolDataHandler(selectedToolId: string) {
        this.calculationResult.output.tools.forEach((x) => (x.isSelected = false));
        this.calculationResult.output.tools.find((x) => x.id === selectedToolId).isSelected = true;
        this.selectedTool = this.calculationResult.output.tools.find((x) => x.id === selectedToolId);
        this.outputTabIndex = 1;
    }

    ShowToolSelection() {
        let dialogRef = this.modelService.open(ToolSelectionComponent, {
            size: 'xl',
        });
        dialogRef.componentInstance.toolsData = this.toolsData;
        dialogRef.componentInstance.calculationType = this.calculationType;
        dialogRef.componentInstance.selectedTaggedItem = this.taggedItem;
        dialogRef.componentInstance.selectedTool = this.selectedTool;
        dialogRef.componentInstance.ResultEvent.subscribe((data: boolean) => {
            if (data) {
                if (this.globalEmittersService.selectedTools.getValue()) {
                    const Obj = this.calculationResult?.output?.tools.find((item) => item.id === this.globalEmittersService.selectedTools.getValue());
                    if (Obj) {
                        Obj.isSelected = true;
                    }
                }
                let calculationResultString = JSON.stringify(this.calculationResult).replace(/ "'/g, " $Inch$'").replace(/ ""/g, ' $Inch$"'); //To remove double quote issue
                let result = {
                    calculationResultString: calculationResultString,
                    calculationResult: this.calculationResult,
                };
                this.CalculationResultString.emit(result);
                if (!this.PageMethod) {
                    this.PlantmanagerService.saveAfterToolSelection = true;
                    this.PlantmanagerService.IsSaveFromTool = true;
                    this.globalEmittersService.saveFromFlangeDetails.next(true);
                    this.globalEmittersService.isSaveFromToolsubscription.next(true);
                }
            }
        });
    }

    async getpipeSpec() {
        try {
            let instanceId = localStorage.getItem('currentInstanceId');
            this.ngxUiLoaderService.start();
            let res = await this.idmapiService.getOnlypipeSpec(instanceId).toPromise();

            if (res.success) {
                this.pipeCodes = res.response;
                if (res.response?.length > 0) {
                    // if (this.jointCalcService?.savedPipeCode) {
                    //     this.pipeSpec = this.jointCalcService.savedPipeCode;
                    // } else {
                    this.pipeSpec =
                        this.jointCalcService.pipeSpecpayload.pipeCode && res?.response.some((m) => m.name === this.jointCalcService.pipeSpecpayload.pipeCode)
                            ? this.jointCalcService.pipeSpecpayload.pipeCode
                            : 'Custom';
                    this.cd.detectChanges();
                    // }
                }
                this.ngxUiLoaderService.stop();
            } else {
                this.ngxUiLoaderService.stop();
                this.user_utility.errorModelPopup(res.message);
            }
        } catch (err) {
            this.ngxUiLoaderService.stop();
        }
    }

    async onPipeSpecChange(event: any) {
        this.jointCalcService.activePipeSpecVersionId = '';
        if (event.value === 'Custom') {
            this.jointCalcService.pipeSpecpayload.pipeCode = null;
            this.jointCalcService.pipeSpecpayload.lookupParams.calculationType = null;

            this.jointCalcService.pipeSpecList = [];
            this.jointCalcService.PipeSpecFilteredList = [];
            this.jointCalcService.isPipeCode = false;
            this.jointCalcService.ispipeSpec.emit(false);
            this.showComponents = false;
            this.jointCalcService.selectedPipeCode = 'Custom';
            if (this.dataSvc.calculationData) {
                this.dataSvc.calculationData = null;
            }
            this.cd.detectChanges();
            setTimeout(() => {
                this.showComponents = true;
                this.cd.detectChanges();
            });
        } else {
            let pipeCode = event.value;
            this.jointCalcService.selectedPipeCode = pipeCode;
            if (pipeCode != null || pipeCode != undefined) {
                this.jointCalcService.pipeSpecpayload = new PipeSpecpayload();
                this.jointCalcService.pipeSpecpayload.lookupParams = new InputGroup();
                this.jointCalcService.pipeSpecpayload.pipeCode = pipeCode;
                this.jointCalcService.pipeSpecpayload.lookupParams.calculationType = this.calculationType;
                if (this.dataSvc.calculationData) {
                    this.dataSvc.calculationData = null;
                }
                let pipeCodeList = await this.idmapiService.findpipespecs(this.jointCalcService.pipeSpecpayload).toPromise();
                if (pipeCodeList.success && pipeCodeList?.response?.length) {
                    this.jointCalcService.pipeSpecList = pipeCodeList?.response;
                    this.jointCalcService.PipeSpecFilteredList = pipeCodeList?.response;
                    this.jointCalcService.isPipeCode = true;
                    this.jointCalcService.ispipeSpec.emit(true);
                    this.showComponents = false;
                    this.cd.detectChanges();

                    setTimeout(() => {
                        this.showComponents = true;
                        this.cd.detectChanges();
                    });
                } else {
                    this.jointCalcService.pipeSpecpayload.pipeCode = null;
                    this.jointCalcService.pipeSpecpayload.lookupParams.calculationType = null;

                    this.jointCalcService.pipeSpecList = [];
                    this.jointCalcService.PipeSpecFilteredList = [];
                    this.jointCalcService.isPipeCode = false;
                    this.jointCalcService.ispipeSpec.emit(false);
                    this.showComponents = false;
                    this.cd.detectChanges();
                    setTimeout(() => {
                        this.showComponents = true;
                        this.cd.detectChanges();
                    });
                }
            }
        }
    }
    //End
}
